import React, { Component } from "react";
import {Card, Form, Table, Spin, DatePicker, Row, Col, Button} from "antd";
import getDate from 'util/ConfigDates'
import { connect } from "react-redux";
import Moment from 'moment';
import Modal from './Modal';

import {
  fetchNotifications,
} from "appRedux/actions/Notifications";
import ModalDelete from "./ModalDelete";
import ModalEdit from "./ModalEdit";

const FormItem = Form.Item
function confirm(e) {
}

function cancel(e) {
}

function status(status){
  if(status==0){
    return "Procesada"
  }else if (status==1){
    return "No Procesada"
  }
}


class Simple extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFrom:getDate('dateFrom'),
      dateTo:getDate('dateTo') //getDate('dateTo'),
    }
  }
  
  state = {
    dateFrom: getDate('dateFrom'),
    dateTo: getDate('dateTo'),
  }
    
  componentDidMount () {
    this.props.fetchNotifications();

  }

  onHandleClick = event => {
    event.preventDefault()
    if (this.state.dateFrom !== '' && this.state.dateTo !== '') {
      
      console.log(this.state);
      this.props.fetchNotifications()
    }
  }

  onClickDateFrom = (date, dateString) => {
    console.log(dateString);
    this.setState({dateFrom: dateString})
  }

  onClickDateTo = (date, dateString) => {
    console.log(dateString);
    this.setState({dateTo: dateString})
  }

  render () {

    const {dateFrom, dateTo} = this.state

    const columns = [
      
      {
        title: 'Id ',
        dataIndex: 'id',
        key: 'id',
        }, {
        title: 'Desde ',
        dataIndex: 'date_to',
        key: 'date_to',
        }, {
        title: 'Hasta',
        dataIndex: 'date_from',
        key: 'date_from',
      }, {
        title: 'Titulo',
        dataIndex: 'title',
        key: 'title',
        },
          {
            title: 'Fecha de envío',
            dataIndex: 'send_date',
            key: 'send_date',
            },
            {
        title: 'Acción',
        key: 'action',
      
      
        render: (text, record) => (
          <span>
            <ModalDelete dataState={this.state}  recording = {record} />
            <ModalEdit  dataState={this.state} recording = {record} />
          </span>
        ),
      }
    ];
    const { notifications } = this.props;
    console.log("Notificaciones:", notifications);

    let notificationsDecode = [];
    notificationsDecode = notifications.map( (notifications)=> {
      return ({
        id: notifications.id,
        date_to: notifications.date_to,
        date_from: notifications.date_from,
        title: notifications.title,
        message: notifications.message,
        status: status(notifications.status),
        send_date: notifications.send_date,
        urlImagen:notifications.urlImage
      })
    });


    return (

      <div>
      <Card title="Notificaciones">
        <Row className="padding-modal">
        
        <Col lg={6} md={6} sm={24} xs={24}>
          <Modal/>
          </Col>
          </Row>
        <Card>
        <Row className="padding-modal">
          <Col lg={10} md={10} sm={10} xs={10}>
          <FormItem
            label="Desde :"
          >
          <DatePicker renderExtraFooter={() => 'extra footer'} defaultValue={Moment(dateFrom)} onChange={this.onClickDateFrom} placeholder="Desde:"/>
          </FormItem>
          </Col>
          <Col lg={10} md={10} sm={10} xs={10}>
          <FormItem
            label="Hasta :"
          >
          <DatePicker renderExtraFooter={() => 'extra footer'} defaultValue={Moment(dateTo).add('days',7)} onChange={this.onClickDateTo} placeholder="Hasta:"/>
          </FormItem>
          </Col>
          <Col lg={4} md={4} sm={4} xs={4}>
              <Button type="primary" onClick={this.onHandleClick}>
                <i className="icon icon-search" />
              </Button>
            </Col>
        </Row>
        </Card>
        <br/>
        <Table className="gx-table-responsive" columns={columns} dataSource={notificationsDecode}/>
      
      </Card>
      </div>
    );
  }
};

function mapStateToProps({notifications}) {
  return {
    notifications
  }
}

export default connect (mapStateToProps, { fetchNotifications })(Simple);


// WEBPACK FOOTER //
// ./src/routes/main/Notification/Table.js